import React from 'react';
import './LoadingModal.scss';

interface ILoadingModalProps {
  show: boolean;
  text?: string;
}

const LoadingModal = ({ show, text = "Carregando..." }: ILoadingModalProps) => {
  if (!show) return null;

  return (
    <div className="loading-modal-overlay">
      <div className="height-100">
        <div className="spinnerInfoBox display-flex justify-content-center align-items-center height-100pct">
          <div className="spinner"></div>
          <div className="spinnerText">{text}</div>
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;
